import { STATUS_CFG } from '@/utils/statusConfig';

const StatusSelect = ({ currentStatus, isRTL, onSelect }) => (
  <div className="flex items-center gap-1 shrink-0">
    {Object.entries(STATUS_CFG).map(([key, cfg]) => (
      <button key={key} data-testid={`status-opt-${key}`}
        onClick={(e) => { e.stopPropagation(); onSelect(key); }}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border transition-all ${
          currentStatus === key
            ? `${cfg.badge} ring-1 ring-offset-1 ${key === 'completed' ? 'ring-emerald-300' : key === 'waiting_approval' ? 'ring-blue-300' : 'ring-amber-300'}`
            : 'border-slate-200 text-slate-400 hover:border-slate-300 hover:text-slate-500'
        }`}>
        {currentStatus === key && <div className={`w-1.5 h-1.5 rounded-full ${cfg.bg}`} />}
        {isRTL ? cfg.ar : cfg.en}
      </button>
    ))}
  </div>
);

export default StatusSelect;
